import Configuracao from "../misc/Configuracao";
import ClienteEnvelope from "./ClienteEnvelope";

interface IMensagemEnvelope {
    data: string;
}

class ClienteEnvelopeApi {
    _clienteEnvelope;
    _clienteEnvelopeId;

    constructor() {
        this._clienteEnvelope = null;
        this._clienteEnvelopeId = null;
        ClienteEnvelope._iniciarModulos();
    }

    acompanharGabinete(gabinete: string, callback: (mensagem: IMensagemEnvelope) => void) {
        if (!gabinete) {
            return;
        }
        const canal = `/GE/${gabinete}`;
        this._acompanharCanal(canal, callback);
    }

    get clienteEnvelopeId() {
        return this._clienteEnvelopeId;
    }

    _acompanharCanal(canal, callback) {
        if (!this._clienteEnvelope) {
            this._iniciarEnvelope();
        }
        if (callback && !this._clienteEnvelope.canalEstaRegistrado(canal)) {
            this._clienteEnvelope.registrarCanal(canal, callback);
        }
    }

    _canalEstaRegistrado(canal) {
        return this._clienteEnvelope.canalEstaRegistrado(canal);
    }

    cancelarTodosAcompanhamentos() {
        if (this._clienteEnvelope) {
            this._finalizarEnvelope();
        }
    }

    _finalizarEnvelope() {
        this._clienteEnvelope.finalizar();
        this._clienteEnvelope = null;
        this._clienteEnvelopeId = null;
    }

    async _iniciarEnvelope() {
        const settings = { url: Configuracao.urlReceberNotificacao };
        if ((window as any).envelope) {
            console.info('envelope settings', settings);
            this._clienteEnvelope = (window as any).envelope.novoClienteMultiplosCanais(settings);
            this._clienteEnvelope.iniciar(function (h) {
                this._clienteEnvelopeId = h.clientId;
                console.info('Envelope iniciado, clienteEnvelopeId: ' + this._clienteEnvelopeId);
            }.bind(this));
        } else {
            console.info('Erro ao carregar script para conexão com Envelope!');
        }
    }
}
export default new ClienteEnvelopeApi();
